module.exports = __webpack_public_path__ + "static/media/estrellaDammCupCatalan.b7377199.jpg";